import Link from "next/link";
import { Pages } from "../../src/list/PageList";
import { useRouter } from "next/router";
import { useState, useEffect, useRef } from "react";

export default function Pagination() {
  const page_1 = useRef(null);
  const page_2 = useRef(null);
  const page_3 = useRef(null);
  const page_4 = useRef(null);
  const page_L = useRef(null);
  const page_F = useRef(null);
  const [load, reload] = useState(0);

  const path = useRouter();
  const pathName = path.query.id;

  function click() {
    reload(load + 1);
  }

  function Classname() {
    page_1.current.className = "numb ";
    page_2.current.className = "numb ";
    page_3.current.className = "numb ";
    //page_4.current.className = "numb ";

    if (pathName != undefined && path.pathname == "/page/[id]") {
      //href set up
      if (pathName == 2) {
        page_2.current.className = "numb active";
      }
      if (pathName == 3) {
        page_3.current.className = "numb active";
      }
      if (pathName == 4) {
        // page_4.current.className = "numb active";
      }
    }

    if (path.pathname == "/") {
      page_1.current.className = "numb active";
      page_F.current.style.display = "none";
    } else {
      page_F.current.style.display = "block";
    }

    if (pathName != undefined && path.pathname == "/page/[id]") {
      if (pathName == Pages.length + 1) {
        page_L.current.style.display = "none";
      } else {
        page_L.current.style.display = "block";
      }
    }
  }

  useEffect(() => {
    Classname();
  });

  return (
    <div className="page_nav">
      <div className="pagination">
        <ul>
          <li>Page:</li>
          <li>
            <Link href={"/"} prefetch={false}>
              <a aria-label="Go to Home">
                <div ref={page_F} className="numb" onClick={click}>
                  <span className="spantext">{"<<"}</span>{" "}
                </div>
              </a>
            </Link>
          </li>
          <li>
            <Link href={"/"} prefetch={false}>
              <a aria-label="Go to Home">
                <div ref={page_1} className="numb" onClick={click}>
                  <span className="spantext">1</span>{" "}
                </div>
              </a>
            </Link>
          </li>
          <li>
            <Link href={"/page/2"} prefetch={false}>
              <a aria-label="Go to page 2">
                <div ref={page_2} className="numb" onClick={click}>
                  <span className="spantext">2</span>{" "}
                </div>
              </a>
            </Link>
          </li>
          <li>
            <Link href={"/page/3"} prefetch={false}>
              <a  aria-label="Go to page 3">
                <div ref={page_3} className="numb no" onClick={click}>
                  <span className="spantext">3</span>{" "}
                </div>
              </a>
            </Link>
          </li>
          {/* <Link href={"/page/4"}>
            <a>
              <div ref={page_4} className="numb no" onClick={click}>
                <span className="spantext">4</span>{" "}
              </div>
            </a>
          </Link> */}

          <li>
            <Link href={"/page/" + (Pages.length + 1)} prefetch={false}>
              <a aria-label="Go to pages">
                <div ref={page_L} className="numb" onClick={click}>
                  <span className="spantext">{">>"}</span>{" "}
                </div>
              </a>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
}
